import React from 'react';
import { useTranslation } from '../context/TranslationContext';
import { SERVICES, anchorOf, requestService } from '../data/services';
import { IsoArt, ART } from './IsoArt';
import { T } from './Typo';

const ARTS = ['web', 'tools', 'integrations', 'automation', 'assistant', 'maintenance'];

const COPY = {
  es: {
    title: 'Qué hacemos',
    lead: 'Puedes pedirnos una sola de estas cosas o juntar varias en el mismo proyecto. Usamos IA para leer documentos y preparar borradores. En muchos proyectos no hace falta.',
    more: 'Ejemplos y qué te entregamos',
    examples: 'Por ejemplo',
    deliver: 'Te entregamos',
    ask: 'Pedir presupuesto',
  },
  en: {
    title: 'What we do',
    lead: 'We do a bit of everything, sized and priced for each project. This is what people ask us for most.',
    more: 'Examples and what you get',
    examples: 'For example',
    deliver: 'You get',
    ask: 'Get a quote',
  },
};

export default function Services() {
  const { lang } = useTranslation();
  const c = COPY[lang] || COPY.es;

  return (
    <section id="que-hacemos" className="section" aria-labelledby="que-hacemos-title">
      <div className="wrap">
        <header className="sec-head">
          <h2 id="que-hacemos-title" className="t-1">{c.title}</h2>
          <p className="t-lead">{c.lead}</p>
        </header>
        <ul className="services">
          {SERVICES.map((s, i) => {
            const d = s[lang] || s.es;
            return (
              <li key={s.id} id={anchorOf(s.id)} className="service">
                <div className="service-art"><IsoArt {...ART[ARTS[i]]} s={20} /></div>
                <span className="service-id">{s.id}</span>
                <h3 className="t-3">{d.name}</h3>
                <p className="service-line"><T>{d.line}</T></p>
                <details className="service-more">
                  <summary>{c.more}</summary>
                  <dl className="service-lists">
                    <div><dt>{c.examples}</dt><dd><ul>{d.examples.map((e) => <li key={e}><T>{e}</T></li>)}</ul></dd></div>
                    <div><dt>{c.deliver}</dt><dd><ul>{d.deliver.map((e) => <li key={e}><T>{e}</T></li>)}</ul></dd></div>
                  </dl>
                </details>
                <a href="#contacto" className="service-ask" onClick={() => requestService(s.id)}>
                  {c.ask}<span className="sr-only">: {d.name}</span> <span aria-hidden="true">→</span>
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
